import type { ChatMessage } from '../../types/chat'
import type { PatientContext } from '../../types/widget'
import { normalizePatientContext, patientIdFromOpenPatientDossierUrl } from '../../utils/sportsNocFlow'
import type { ActivePatientSyncPayload } from './types'

/** Normalize embed ``patientContext`` (host may send snake_case). */
export function activePatientPayloadFromHostPatientContext(
  raw: PatientContext | Record<string, unknown> | undefined,
): ActivePatientSyncPayload | null {
  const n = normalizePatientContext(raw)
  if (!n) return null
  const patient_id = (n.patientId ?? '').trim()
  const patient_name = (n.name ?? '').trim()
  if (!patient_id && !patient_name) return null
  return {
    ...(patient_id ? { patient_id } : {}),
    ...(patient_name ? { patient_name } : {}),
  }
}

export function latestOpenPatientPayloadFromChatMessages(
  messages: readonly ChatMessage[],
): ActivePatientSyncPayload | null {
  for (let i = messages.length - 1; i >= 0; i--) {
    const m = messages[i]
    if (m.role !== 'assistant') continue
    const name = (m.activePatientNameHint || '').trim()
    const hintId = (m.activePatientIdHint || '').trim()
    const url = (m.openPatientDossierUrl || '').trim()
    const patient_id = hintId || (url ? patientIdFromOpenPatientDossierUrl(url) : undefined)
    if (!name && !patient_id) continue
    return {
      ...(patient_id ? { patient_id } : {}),
      ...(name ? { patient_name: name } : {}),
    }
  }
  return null
}

export function latestPendingModalityPatientPayloadFromChatMessages(
  messages: readonly ChatMessage[],
): ActivePatientSyncPayload | null {
  for (let i = messages.length - 1; i >= 0; i--) {
    const pm = messages[i].pendingModalityExam
    if (!pm) continue
    const patient_name = (pm.targetPatientName ?? '').trim()
    const patient_id = (pm.targetPatientId ?? '').trim()
    if (!patient_name && !patient_id) continue
    return {
      ...(patient_id ? { patient_id } : {}),
      ...(patient_name ? { patient_name } : {}),
    }
  }
  return null
}

export function mergeActivePatientPayloadForSessionSync(
  host: ActivePatientSyncPayload | null,
  chat: ActivePatientSyncPayload | null,
): ActivePatientSyncPayload | null {
  const patient_id = (chat?.patient_id || host?.patient_id || '').trim()
  const patient_name = (chat?.patient_name || host?.patient_name || '').trim()
  if (!patient_id && !patient_name) return null
  return {
    ...(patient_id ? { patient_id } : {}),
    ...(patient_name ? { patient_name } : {}),
  }
}
